/* eslint-disable no-useless-escape */
import React from 'react';
import classnames from 'classnames';
import jsonp from 'jsonp';
import queryString from 'query-string';
import { useState } from 'react';

import Button from 'ui/common/button';
import styles from './index.module.scss';

const GetInvolved = () => {
  const [emailInput, setEmailInput] = useState('');
  const [isSubscribed, setSubscribed] = useState(false);
  const MAILCHIMP_URL =
    'https://indorse.us15.list-manage.com/subscribe/post-json?u=93f666ec18288ad384d11f649&amp;id=9e2ecefee6&';
  const validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const onInputChange = event => {
    let value = event.target.value;
    setEmailInput(value);
  };

  const onSubscirbe = props => {
    const formData = { EMAIL: emailInput };
    jsonp(`${MAILCHIMP_URL}${queryString.stringify(formData)}`, { param: 'c' }, (err, data) => {
      console.log(err);
      console.log(data);
      setSubscribed(true);
    });
  };

  return (
    <div className={classnames(styles.whiteBackground)}>
      <div className={classnames('page-max-width')}>
        <div>
          <h2 className={classnames(styles.title)}>Get Involved</h2>
          <h3 className={classnames(styles.subtitle)}>
            Become a part of an active Indorse community.
          </h3>
        </div>

        <div className={classnames(styles.grid, 'container')}>
          <div className={classnames(styles.image)}>
            <img src="/Get_Involved.png" alt="get-involved" width="100%" />
          </div>
          <div className="mx-auto">
            <h2 className={classnames(styles.heading)}>Mini Newsletter!</h2>
            <div className={classnames(styles.email)}>
              <input
                type="text"
                name="email"
                placeholder="Enter your email"
                onChange={onInputChange}
                value={emailInput}
              />
            </div>
            <div className={classnames(styles.flex, 'mt-3')}>
              <Button
                color="primary-rect"
                onClick={onSubscirbe}
                disabled={!validateEmail(emailInput)}
                href=""
              >
                {isSubscribed ? 'Subscribed' : 'Join Now'}
              </Button>
            </div>
          </div>
        </div>

        <div className={classnames(styles.grid, 'container mt-5')}>
          <div className="mx-auto">
            <h2 className={classnames(styles.heading)}>Connect on Discord</h2>
            <h3 className={classnames(styles.text)}>
              Connect with the community on the discord. Explore tech, ask questions, and be an
              integral part of the ever-growing community of Indorse.
            </h3>
            <div className={classnames(styles.joinContainer)}>
              <Button color="primary-rect" href="https://discord.com/invite/KbFG7kr">
                Join Now
              </Button>
            </div>
          </div>
          <div className={classnames(styles.image)}>
            <img
              src="https://indorse-staging-bucket.s3.amazonaws.com/Discord.png"
              alt="discord"
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInvolved;

// < !--Begin Mailchimp Signup Form-- >
//   <link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css">
//     <style type="text/css">
//       #mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; }
// 	/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
// 	   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
// </style>
//     <div id="mc_embed_signup">
//       <form action="https://indorse.us15.list-manage.com/subscribe/post?u=93f666ec18288ad384d11f649&amp;id=9e2ecefee6" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
//         <div id="mc_embed_signup_scroll">
//           <h2>Subscribe</h2>
//           <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
//           <div class="mc-field-group">
//             <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
//             </label>
//             <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
// </div>
//             <div id="mce-responses" class="clear">
//               <div class="response" id="mce-error-response" style="display:none"></div>
//               <div class="response" id="mce-success-response" style="display:none"></div>
//             </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
//     <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_93f666ec18288ad384d11f649_9e2ecefee6" tabindex="-1" value=""></div>
//               <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
//               </div>
// </form>
//           </div>
//           <script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';}(jQuery));var $mcj = jQuery.noConflict(true);</script>
//           <!--End mc_embed_signup--></div>
